import { Spinner } from '@repo/design-system-kit/components/spinner/spinner';
import styles from './loading.module.css';

export function KycLoading() {
  return (
    <main className={styles.loadingState}>
      <Spinner size="large" />
    </main>
  );
}
